<div class="d-flex flex-column">
    <!-- Header -->
    <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail modal-close" style="padding-top: 3px;" (click)="onCancelClicked()">
        <svg class="icon-16">
            <use href="../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
        </svg>
    </button>
    <div class="modal-header">
        <span cvLocalizedText langSection="Share_URL" langKey="Share_URL">Share URL</span>
    </div>

    <!-- Body -->
    <div class="modal-body">
        <div class="body-title" cvLocalizedText langSection="Share_URL" langKey="Read_Only_Title">Shared Read-Only Link</div>
        <div class="details-text" cvLocalizedText langSection="Share_URL" langKey="Read_Only_Desc">Dashboard URL will have read-only permission and widgets that require a login (Games, Challenges, Supervisor Games, etc.) will not load data.</div>
        <div class="d-flex flex-row">
            <mat-slide-toggle [(ngModel)]="enabled" (ngModelChange)="onToggleClicked()"></mat-slide-toggle>
            <span class="enable-toggle" cvLocalizedText langSection="Share_URL" langKey="Enable">Enabled dashboard sharing with a public shared link</span>
        </div>
        <div class="body-title" cvLocalizedText langSection="Share_URL" langKey="Share_URL">Share URL</div>
        <div style="margin-top: -12px;">
            <input #shareURLLink type="text" class="url-display" [value]="shareURL" disabled>
            <button type="button" class="copy-btn" (click)="onCopyClicked()" [disabled]="!enabled" cvLocalizedText langSection="Common" langKey="Copy_Button">Copy</button>
            
            <ng-template #refreshPopover>
                <div>
                    <div class="details-text" cvLocalizedText langSection="Share_URL" langKey="Refresh_URL">Refreshing a URL will deactivate the previous link</div>
                    <div class="d-flex mx-1" style="justify-content: flex-end;">
                        <button class="btn btn-secondary modal-footer-btn" type="button" style="margin-right: 10px" (click)="refreshLinkCancel()" cvLocalizedText [langSection]="'Module_Menu'" [langKey]="'Cancel'">Cancel</button>
                        <button class="btn btn-primary modal-footer-btn" type="button" (click)="refreshLinkConfirm()" cvLocalizedText [langSection]="'Module_Menu'" [langKey]="'Refresh'">Refresh</button>
                    </div>
                </div>
            </ng-template>
            
            <button 
                type="button" 
                class="create-new-link-btn"
                [popover]="refreshPopover"
                #refreshLinkPopover="bs-popover"
                placement="right"
                [adaptivePosition]="true"
                [outsideClick]="false"
                triggers="manual"
                (click)="onRefreshLinkClicked()"
                [disabled]="!enabled"
                cvLocalizedText
                langSection="Share_URL"
                langKey="Refresh_Link"
                >
                Refresh Link
            </button>
        </div>
        <div *ngIf="linkCopied" class="link-copied" cvLocalizedText langSection="Share_URL" langKey="Link_Copied">Link copied</div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
        <button 
            type="button" 
            class="btn btn-secondary modal-footer-btn" 
            cvLocalizedText [langSection]="'Common'" [langKey]="'Cancel_Button'"
            (click)="onCancelClicked()">Cancel</button>
        <button 
            type="button" 
            class="btn btn-primary modal-footer-btn" 
            cvLocalizedText [langSection]="'Common'" [langKey]="'Save_Button'"
            (click)="onSaveClicked()">Save</button>
    </div>
</div>
